"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRenderLabels = exports.useLabels = void 0;
var client_1 = require("@apollo/client");
var vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
var react_query_1 = require("@tanstack/react-query");
var react_1 = __importDefault(require("react"));
var Localize_1 = require("../../../../gen-src/Localize");
var queries_1 = require("../../../../gen-src/queries");
var FeatureFlagsContext_1 = require("../../featureFlags/FeatureFlagsContext");
var useDebounceWithLoading_1 = require("../../hooks/useDebounceWithLoading");
var useTelemetrySender_1 = require("../../hooks/useTelemetrySender");
var TelemetryContext_1 = require("../../telemetry/TelemetryContext");
var TypescriptHelpers_1 = require("../../utils/TypescriptHelpers");
var LabelButtons_1 = require("../LabelButtons");
var LabelHelpers_1 = require("../LabelHelpers");
var LabelTypes_1 = require("../restApi/LabelTypes");
var Labels_1 = require("../restApi/Labels");
var LabelType_1 = require("../shared/LabelType");
var HookContext_1 = require("./HookContext");
var getUsers_1 = require("./getUsers");
var LABELS_CACHE_RELOAD_TIME = 300000;
function getRestLabels(items, params) {
    return __awaiter(this, void 0, void 0, function () {
        var makeJsonRestApiRequest, result, labels;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!items.contentType || !(0, LabelTypes_1.isLabelContentType)(items.contentType) || !items.contentLuid) {
                        return [2 /*return*/, []];
                    }
                    makeJsonRestApiRequest = (0, vizportalclient_common_components_1.restApiService)(params).makeJsonRestApiRequest;
                    return [4 /*yield*/, (0, Labels_1.getLabels)({
                            contentItems: [{
                                    contentId: items.contentLuid,
                                    contentType: items.contentType,
                                    contentName: items.contentName,
                                }],
                            makeJsonRestApiRequest: makeJsonRestApiRequest,
                            transform: function (t) { return t; },
                        })];
                case 1:
                    result = _a.sent();
                    labels = result.get({ contentId: items.contentLuid, contentType: items.contentType.toLowerCase() });
                    return [2 /*return*/, labels !== null && labels !== void 0 ? labels : []];
            }
        });
    });
}
function urlForContentType(siteUrls, contentType, id, tableIdForColumn) {
    if (!siteUrls || !contentType || !id) {
        return undefined;
    }
    switch (contentType) {
        case 'PublishedDatasource':
            return siteUrls.datasourceUrl(id);
        case 'Flow':
            return siteUrls.flowUrl(id);
        case 'CloudFile':
        case 'DatabaseServer':
        case 'File':
        case 'WebDataConnector':
            return siteUrls.catalogDatabaseUrl(id);
        case 'VirtualConnection':
            return siteUrls.virtualConnectionUrl(id);
        case 'VirtualConnectionTable':
            return siteUrls.virtualConnectionTableUrl(id);
        case 'DatabaseTable':
            return siteUrls.catalogTableUrl(id);
        case 'Column':
            return siteUrls.catalogTableColumnUrl(tableIdForColumn !== null && tableIdForColumn !== void 0 ? tableIdForColumn : '', id);
        default:
            return undefined;
    }
}
function getProperIdFromContent(asset) {
    if (!asset) {
        return undefined;
    }
    if ('vizportalUrlId' in asset) {
        return asset.vizportalUrlId;
    }
    if ('id' in asset) {
        return asset.id;
    }
    return undefined;
}
function buildLabelContentItemFromLabelFragment(label, controls) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    return {
        contentId: getProperIdFromContent(label.asset),
        contentLuid: (_a = label.asset) === null || _a === void 0 ? void 0 : _a.luid,
        contentName: (_c = (_b = label.asset) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : undefined,
        contentType: (_e = (_d = label.asset) === null || _d === void 0 ? void 0 : _d.__typename) !== null && _e !== void 0 ? _e : null,
        contentIcon: (_j = (0, LabelHelpers_1.assetIconForType)((_g = (_f = label.asset) === null || _f === void 0 ? void 0 : _f.__typename) !== null && _g !== void 0 ? _g : null, ((_h = label.asset) === null || _h === void 0 ? void 0 : _h.__typename) === "Column" ? label.asset.remoteType : undefined)) !== null && _j !== void 0 ? _j : undefined,
        subjectArea: (_k = label.asset) === null || _k === void 0 ? void 0 : _k.__typename,
        contentUrl: urlForContentType(controls === null || controls === void 0 ? void 0 : controls.siteUrls, (_l = label.asset) === null || _l === void 0 ? void 0 : _l.__typename, getProperIdFromContent(label.asset), ((_m = label.asset) === null || _m === void 0 ? void 0 : _m.__typename) === 'Column' ? (_o = label.asset.table) === null || _o === void 0 ? void 0 : _o.id : undefined),
        remoteType: ((_p = label.asset) === null || _p === void 0 ? void 0 : _p.__typename) === "Column" ? label.asset.remoteType : undefined,
    };
}
function buildParentLabelContentItemFromLabelFragment(label, controls) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    if (((_a = label.asset) === null || _a === void 0 ? void 0 : _a.__typename) !== 'Column') {
        return undefined;
    }
    return {
        contentId: (_b = label.asset.table) === null || _b === void 0 ? void 0 : _b.id,
        contentType: ((_c = label.asset.table) === null || _c === void 0 ? void 0 : _c.__typename) === undefined || ((_d = label.asset.table) === null || _d === void 0 ? void 0 : _d.__typename) === 'CustomSQLTable' ? null : (_e = label.asset.table) === null || _e === void 0 ? void 0 : _e.__typename,
        contentName: (_g = (_f = label.asset.table) === null || _f === void 0 ? void 0 : _f.name) !== null && _g !== void 0 ? _g : undefined,
        contentUrl: urlForContentType(controls === null || controls === void 0 ? void 0 : controls.siteUrls, (_h = label.asset.table) === null || _h === void 0 ? void 0 : _h.__typename, (_j = label.asset.table) === null || _j === void 0 ? void 0 : _j.id, undefined),
    };
}
function convertLabelFragmentToRenderLabelWarning(label, controls) {
    var _a, _b;
    return {
        type: (0, LabelType_1.stringToDataQualityType)(label.value),
        active: label.isActive,
        author: (_a = label.author) !== null && _a !== void 0 ? _a : { name: '', username: '', domain: '' },
        message: (_b = label.message) !== null && _b !== void 0 ? _b : '',
        updatedAt: Localize_1.Formatters.formatMediumDateTimeWithoutSeconds(new Date(label.updatedAt)),
        content: buildLabelContentItemFromLabelFragment(label, controls),
        parent: buildParentLabelContentItemFromLabelFragment(label, controls),
        severe: label.isElevated,
    };
}
function convertLabelFragmentToRenderLabelCert(label, controls) {
    var _a, _b;
    return {
        type: (0, LabelType_1.stringToDataQualityType)(label.value),
        active: label.isActive,
        author: (_a = label.author) !== null && _a !== void 0 ? _a : { name: '', username: '', domain: '' },
        message: (_b = label.message) !== null && _b !== void 0 ? _b : '',
        updatedAt: Localize_1.Formatters.formatMediumDateTimeWithoutSeconds(new Date(label.updatedAt)),
        content: buildLabelContentItemFromLabelFragment(label, controls)
    };
}
function convertLabelsFragmentIntoRenderProps(_a) {
    var _b;
    var upstreamLabels = _a.upstreamLabels, item = _a.item, controls = _a.controls, parentedItems = _a.parentedItems, includeParented = _a.includeParented, includeUpstream = _a.includeUpstream;
    if (!upstreamLabels && !parentedItems) {
        return {};
    }
    var upstreamGrouped = upstreamLabels && includeUpstream ? (0, LabelHelpers_1.groupBy)(upstreamLabels, function (key) { return key.category; }) : undefined;
    var upstreamWarnings = upstreamGrouped ? (_b = upstreamGrouped.get('WARNING')) === null || _b === void 0 ? void 0 : _b.map(function (label) {
        return convertLabelFragmentToRenderLabelWarning(label, controls);
    }) : undefined;
    var parentedWarnings = [];
    var parentedCertifications = [];
    if (parentedItems && includeParented) {
        parentedItems.forEach(function (parentedItem) {
            var _a, _b;
            var currGrouped = (0, LabelHelpers_1.groupBy)(parentedItem.labels, function (key) { return key.category; });
            var currParentedWarnings = (_a = currGrouped.get('WARNING')) === null || _a === void 0 ? void 0 : _a.map(function (label) {
                return convertLabelFragmentToRenderLabelWarning(label, controls);
            });
            var currParentedCertifications = (_b = currGrouped.get('CERTIFICATION')) === null || _b === void 0 ? void 0 : _b.map(function (label) {
                return convertLabelFragmentToRenderLabelCert(label, controls);
            });
            if (currParentedWarnings) {
                parentedWarnings = parentedWarnings.concat(currParentedWarnings);
            }
            if (currParentedCertifications) {
                parentedCertifications = parentedCertifications.concat(currParentedCertifications);
            }
        });
    }
    var hydratedWarnings = {
        category: 'warning',
        content: item,
        kind: 'hydrated',
        upstream: upstreamWarnings ? { category: 'warning', labels: upstreamWarnings } : undefined,
        parented: parentedWarnings.length > 0 ? { category: 'warning', labels: parentedWarnings } : undefined
    };
    var hydratedCertifications = {
        category: "certification",
        content: item,
        kind: "hydrated",
        parented: parentedCertifications.length > 0 ? { category: 'certification', labels: parentedCertifications } : undefined,
    };
    return {
        certifications: hydratedCertifications,
        warnings: hydratedWarnings
    };
}
function useGeneralLineageLabelsLazyQueryLuid(_a) {
    var item = _a.item, controls = _a.controls, includeParented = _a.includeParented, includeUpstream = _a.includeUpstream, document = _a.document;
    var _b = (0, client_1.useLazyQuery)(document), fire = _b[0], _c = _b[1], loading = _c.loading, error = _c.error, data = _c.data;
    var invoke = react_1.default.useCallback(function () { var _a; void fire({ variables: { luid: (_a = item.contentLuid) !== null && _a !== void 0 ? _a : null } }); }, [fire, item]);
    var upstreamLabels = (data === null || data === void 0 ? void 0 : data.items[0]) ? data === null || data === void 0 ? void 0 : data.items[0].upstreamLabels : undefined;
    var result = __assign({ loading: loading, error: error }, convertLabelsFragmentIntoRenderProps({ upstreamLabels: upstreamLabels, item: item, controls: controls, includeParented: includeParented, includeUpstream: includeUpstream }));
    return [invoke, result];
}
function useDatabaseTableLineageLabelsLazyQuery(_a) {
    var item = _a.item, controls = _a.controls, includeParented = _a.includeParented, includeUpstream = _a.includeUpstream, document = _a.document;
    var _b = (0, client_1.useLazyQuery)(document), fire = _b[0], _c = _b[1], loading = _c.loading, error = _c.error, data = _c.data;
    var invoke = react_1.default.useCallback(function () { var _a; void fire({ variables: { luid: (_a = item.contentLuid) !== null && _a !== void 0 ? _a : null } }); }, [fire, item]);
    // Because of parentedItems on DatabaseTable it has its own function
    var upstreamLabels = (data === null || data === void 0 ? void 0 : data.items[0]) ? data === null || data === void 0 ? void 0 : data.items[0].upstreamLabels : undefined;
    var parentedItems = (data === null || data === void 0 ? void 0 : data.items[0]) ? data.items[0].columns : undefined;
    var result = __assign({ loading: loading, error: error }, convertLabelsFragmentIntoRenderProps({ upstreamLabels: upstreamLabels, parentedItems: parentedItems, item: item, controls: controls, includeParented: includeParented, includeUpstream: includeUpstream }));
    return [invoke, result];
}
function useColumnLineageLabelsLazyQuery(_a) {
    var item = _a.item, controls = _a.controls, includeParented = _a.includeParented, includeUpstream = _a.includeUpstream, document = _a.document;
    var _b = (0, client_1.useLazyQuery)(document), fire = _b[0], _c = _b[1], loading = _c.loading, error = _c.error;
    var invoke = react_1.default.useCallback(function () { var _a; void fire({ variables: { luid: (_a = item.contentLuid) !== null && _a !== void 0 ? _a : null } }); }, [fire, item]);
    // Columns cannot have upstream labels so they are set to undefined. This function exists for consistency.
    var upstreamLabels = undefined;
    var result = __assign({ loading: loading, error: error }, convertLabelsFragmentIntoRenderProps({ upstreamLabels: upstreamLabels, item: item, controls: controls, includeParented: includeParented, includeUpstream: includeUpstream }));
    return [invoke, result];
}
function useFieldLineageLabelsLazyQuery(_a) {
    var item = _a.item, controls = _a.controls, includeParented = _a.includeParented, includeUpstream = _a.includeUpstream, document = _a.document;
    var _b = (0, client_1.useLazyQuery)(document), fire = _b[0], _c = _b[1], loading = _c.loading, error = _c.error, data = _c.data;
    var invoke = react_1.default.useCallback(function () { var _a; void fire({ variables: { id: (_a = item.contentId) !== null && _a !== void 0 ? _a : null } }); }, [fire, item]);
    // Fields follow a different graph query pattern so it has to have its own function
    var labelsContainer = [];
    data === null || data === void 0 ? void 0 : data.items.forEach(function (field) {
        if ('columns' in field) {
            field.columns.forEach(function (column) {
                column.labels.forEach(function (label) {
                    labelsContainer.push(label);
                });
            });
        }
    });
    var upstreamLabels = labelsContainer.length > 0 ? labelsContainer : undefined;
    var result = __assign({ loading: loading, error: error }, convertLabelsFragmentIntoRenderProps({ upstreamLabels: upstreamLabels, item: item, controls: controls, includeParented: includeParented, includeUpstream: includeUpstream }));
    return [invoke, result];
}
function useGeneralLineageLabelsLazyQueryId(_a) {
    var item = _a.item, controls = _a.controls, includeParented = _a.includeParented, includeUpstream = _a.includeUpstream, document = _a.document;
    var _b = (0, client_1.useLazyQuery)(document), fire = _b[0], _c = _b[1], loading = _c.loading, error = _c.error, data = _c.data;
    var invoke = react_1.default.useCallback(function () { var _a; void fire({ variables: { id: (_a = item.contentId) !== null && _a !== void 0 ? _a : null } }); }, [fire, item]);
    var upstreamLabels = (data === null || data === void 0 ? void 0 : data.items[0]) ? data === null || data === void 0 ? void 0 : data.items[0].upstreamLabels : undefined;
    var result = __assign({ loading: loading, error: error }, convertLabelsFragmentIntoRenderProps({ upstreamLabels: upstreamLabels, item: item, controls: controls, includeParented: includeParented, includeUpstream: includeUpstream }));
    return [invoke, result];
}
function useLabelsGraph(item, controls, includeUpstream, includeParented) {
    var _a;
    var column = useColumnLineageLabelsLazyQuery({ item: item, controls: controls, includeUpstream: includeUpstream, includeParented: includeParented, document: queries_1.ColumnLineageLabelsDocument });
    var database = useGeneralLineageLabelsLazyQueryLuid({ item: item, controls: controls, includeUpstream: includeUpstream, includeParented: includeParented, document: queries_1.DatabaseLineageLabelsDocument });
    var databaseTable = useDatabaseTableLineageLabelsLazyQuery({ item: item, controls: controls, includeUpstream: includeUpstream, includeParented: includeParented, document: queries_1.DatabaseTableLineageLabelsDocument });
    var virtualConnectionTable = useGeneralLineageLabelsLazyQueryLuid({ item: item, controls: controls, includeUpstream: includeUpstream, includeParented: includeParented, document: queries_1.VirtualConnectionTablesLineageLabelsDocument });
    var flow = useGeneralLineageLabelsLazyQueryLuid({ item: item, controls: controls, includeUpstream: includeUpstream, includeParented: includeParented, document: queries_1.FlowLineageLabelsDocument });
    var publishedDatasource = useGeneralLineageLabelsLazyQueryLuid({ item: item, controls: controls, includeUpstream: includeUpstream, includeParented: includeParented, document: queries_1.PublishedDatasourceLineageLabelsDocument });
    var embeddedDatasource = useGeneralLineageLabelsLazyQueryId({ item: item, controls: controls, includeUpstream: includeUpstream, includeParented: includeParented, document: queries_1.EmbeddedDatasourceLineageLabelsDocument });
    var virtualConnection = useGeneralLineageLabelsLazyQueryLuid({ item: item, controls: controls, includeUpstream: includeUpstream, includeParented: includeParented, document: queries_1.VirtualConnectionLineageLabelsDocument });
    var view = useGeneralLineageLabelsLazyQueryId({ item: item, controls: controls, includeUpstream: includeUpstream, includeParented: includeParented, document: queries_1.ViewLineageLabelsDocument });
    var workbook = useGeneralLineageLabelsLazyQueryLuid({ item: item, controls: controls, includeUpstream: includeUpstream, includeParented: includeParented, document: queries_1.WorkbookLineageLabelsDocument });
    var field = useFieldLineageLabelsLazyQuery({ item: item, controls: controls, includeUpstream: includeUpstream, includeParented: includeParented, document: queries_1.FieldLineageLabelsDocument });
    var metric = useGeneralLineageLabelsLazyQueryLuid({ item: item, controls: controls, includeParented: includeParented, includeUpstream: includeUpstream, document: queries_1.MetricLineageLabelsDocument });
    switch (item.subjectArea) {
        case 'column':
        case 'Column':
            return column;
        case 'database':
        case 'CloudFile':
        case 'DatabaseServer':
        case 'File':
        case 'WebDataConnector':
            return database;
        case 'table':
        case 'DatabaseTable':
            return databaseTable;
        case 'virtualConnectionTable':
        case 'VirtualConnectionTable':
            return virtualConnectionTable;
        case 'flow':
        case 'Flow':
            return flow;
        case 'datasource':
        case 'PublishedDatasource':
            return publishedDatasource;
        case 'EmbeddedDatasource':
            return embeddedDatasource;
        case 'virtualConnection':
        case 'VirtualConnection':
            return virtualConnection;
        case 'View':
            return view;
        case 'Workbook':
        case 'workbook':
            return workbook;
        case 'Field':
            return field;
        case 'Metric':
        case 'metric':
            return metric;
        default: // Should never hit this
            (0, TypescriptHelpers_1.assertUnreachable)((_a = item.subjectArea) !== null && _a !== void 0 ? _a : 'undefined');
            return [function () { return; }, {}];
    }
}
function mapRestLabelsToRenderProps(labels, authors) {
    var activeLabels = labels ? labels.filter(function (p) { return p.active; }) : [];
    return ({
        warnings: activeLabels.filter(function (p) { return p.category.toLowerCase() === 'warning'; }).map(function (warning) {
            var _a, _b, _c;
            return {
                severe: warning.elevated,
                type: (0, LabelType_1.stringToDataQualityType)(warning.value),
                active: warning.active,
                author: (_c = authors === null || authors === void 0 ? void 0 : authors.get((_b = (_a = warning.owner) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '')) !== null && _c !== void 0 ? _c : { username: '', name: warning.userDisplayName, domain: '' },
                message: warning.message,
                updatedAt: Localize_1.Formatters.formatMediumDateTimeWithoutSeconds(new Date(warning.updatedAt)),
            };
        }),
        certifications: activeLabels.filter(function (p) { return p.category.toLowerCase() === 'certification'; })
            .map(function (c) {
            var _a, _b, _c;
            return {
                type: LabelType_1.LabelType.CERTIFIED,
                active: c.active,
                author: (_c = authors === null || authors === void 0 ? void 0 : authors.get((_b = (_a = c.owner) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '')) !== null && _c !== void 0 ? _c : { username: '', name: c.userDisplayName, domain: '' },
                message: c.message,
                updatedAt: Localize_1.Formatters.formatMediumDateTimeWithoutSeconds(new Date(c.updatedAt)),
            };
        }),
        sensitivities: activeLabels.filter(function (p) { return p.category.toLowerCase() === 'sensitivity'; })
            .map(function (s) {
            var _a, _b, _c;
            return {
                type: LabelType_1.LabelType.SENSITIVE_DATA,
                active: s.active,
                author: (_c = authors === null || authors === void 0 ? void 0 : authors.get((_b = (_a = s.owner) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '')) !== null && _c !== void 0 ? _c : { username: '', name: s.userDisplayName, domain: '' },
                message: s.message,
                updatedAt: Localize_1.Formatters.formatMediumDateTimeWithoutSeconds(new Date(s.updatedAt)),
            };
        }),
    });
}
function useLabelsRest(item, catalogEnabled, contextOverrides) {
    var _a;
    var restApiService = (0, HookContext_1.useContextWithOverride)(vizportalclient_common_components_1.RestApiServiceParamsContext, contextOverrides === null || contextOverrides === void 0 ? void 0 : contextOverrides.restApiServiceParams);
    var queryClientContext = react_1.default.createContext((0, HookContext_1.useContextWithOverride)(react_query_1.defaultContext, contextOverrides === null || contextOverrides === void 0 ? void 0 : contextOverrides.queryClient));
    var _b = react_1.default.useState(false), enabled = _b[0], setEnabled = _b[1];
    var invoke = react_1.default.useCallback(function () { return setEnabled(true); }, []);
    var _c = (0, react_query_1.useQuery)(['labels', item], function () { return getRestLabels(item, restApiService); }, { enabled: enabled, context: queryClientContext }), _labels = _c.data, _labelsLoading = _c.isLoading;
    var users = (_a = _labels === null || _labels === void 0 ? void 0 : _labels.filter(function (l) { return l.owner !== undefined; }).map(function (l) { var _a; return (_a = l.owner) === null || _a === void 0 ? void 0 : _a.id; })) !== null && _a !== void 0 ? _a : [];
    var _d = (0, getUsers_1.useGetGraphUsers)(users), data = _d.data, _usersLoading = _d.loading;
    var _authors = new Map();
    data === null || data === void 0 ? void 0 : data.items.forEach(function (val) {
        _authors.set(val.luid, { name: val.name, domain: val.domain, username: val.username });
    });
    var _e = mapRestLabelsToRenderProps(_labels, _authors), warnings = _e.warnings, certifications = _e.certifications, sensitivities = _e.sensitivities;
    var warningProps = warnings.length > 0 && catalogEnabled ? {
        category: 'warning',
        content: item,
        kind: 'hydrated',
        anchored: {
            category: 'warning',
            labels: warnings
        }
    } : undefined;
    var certificationProps = certifications.length > 0 ? {
        category: 'certification',
        content: item,
        kind: 'hydrated',
        anchored: {
            category: 'certification',
            labels: certifications
        }
    } : undefined;
    var sensitivityProps = sensitivities.length > 0 && catalogEnabled ? {
        category: 'sensitivity',
        content: item,
        kind: 'hydrated',
        anchored: {
            category: 'sensitivity',
            labels: sensitivities
        }
    } : undefined;
    return [invoke, { loading: _usersLoading || _labelsLoading, warnings: warningProps, certifications: certificationProps, sensitivities: sensitivityProps }];
}
function merge(rest, graph, content, sensitiveLabelsEnabled) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
    var certifications = undefined;
    var warnings = undefined;
    var sensitivities = undefined;
    if (((_a = graph.certifications) === null || _a === void 0 ? void 0 : _a.parented) || ((_b = rest.certifications) === null || _b === void 0 ? void 0 : _b.anchored)) {
        certifications = { category: "certification", content: content, kind: "hydrated", anchored: (_c = rest.certifications) === null || _c === void 0 ? void 0 : _c.anchored, parented: (_d = graph.certifications) === null || _d === void 0 ? void 0 : _d.parented };
    }
    if (((_e = graph.warnings) === null || _e === void 0 ? void 0 : _e.parented) || ((_f = graph.warnings) === null || _f === void 0 ? void 0 : _f.upstream) || ((_g = rest.warnings) === null || _g === void 0 ? void 0 : _g.anchored)) {
        warnings = { category: "warning", content: content, kind: "hydrated", upstream: (_h = graph.warnings) === null || _h === void 0 ? void 0 : _h.upstream, anchored: (_j = rest.warnings) === null || _j === void 0 ? void 0 : _j.anchored, parented: (_k = graph.warnings) === null || _k === void 0 ? void 0 : _k.parented };
    }
    if (sensitiveLabelsEnabled && (((_l = graph.sensitivities) === null || _l === void 0 ? void 0 : _l.upstream) || ((_m = graph.sensitivities) === null || _m === void 0 ? void 0 : _m.parented) || ((_o = rest.sensitivities) === null || _o === void 0 ? void 0 : _o.anchored))) {
        sensitivities = { category: "sensitivity", content: content, kind: "hydrated", upstream: (_p = graph.sensitivities) === null || _p === void 0 ? void 0 : _p.upstream, anchored: (_q = rest.sensitivities) === null || _q === void 0 ? void 0 : _q.anchored, parented: (_r = graph.sensitivities) === null || _r === void 0 ? void 0 : _r.parented };
    }
    return {
        loading: (_s = (rest.loading || graph.loading)) !== null && _s !== void 0 ? _s : undefined,
        error: (_u = (_t = rest.error) !== null && _t !== void 0 ? _t : graph.error) !== null && _u !== void 0 ? _u : undefined,
        certifications: certifications,
        warnings: warnings,
        sensitivities: sensitivities
    };
}
function useLabels(_a) {
    var catalogEnabled = _a.catalogEnabled, content = _a.content, includeUpstream = _a.includeUpstream, includeParented = _a.includeParented, controls = _a.controls, contextOverrides = _a.contextOverrides;
    var sensitiveLabelsEnabled = react_1.default.useContext(FeatureFlagsContext_1.FeatureFlagsContext).sensitiveLabelsEnabled;
    var _b = useLabelsRest(content, catalogEnabled, contextOverrides), invokeRest = _b[0], dataRest = _b[1];
    var _c = useLabelsGraph(content, controls, includeUpstream, includeParented), invokeGraph = _c[0], dataGraph = _c[1];
    var invoke = react_1.default.useCallback(function () {
        invokeRest();
        if (catalogEnabled && (includeUpstream || includeParented)) {
            invokeGraph();
        }
    }, [catalogEnabled, includeUpstream, includeParented, invokeRest, invokeGraph]);
    return [invoke, merge(dataRest, dataGraph, content, sensitiveLabelsEnabled)];
}
exports.useLabels = useLabels;
function isSevere(probably, data) {
    var _a, _b, _c, _d;
    if (probably === null || probably === void 0 ? void 0 : probably.warning) {
        return (_a = probably === null || probably === void 0 ? void 0 : probably.warning) === null || _a === void 0 ? void 0 : _a.severe;
    }
    var severe = false;
    if (data) {
        (_b = data.anchored) === null || _b === void 0 ? void 0 : _b.labels.forEach(function (label) {
            if (label.severe) {
                severe = true;
            }
        });
        (_c = data.upstream) === null || _c === void 0 ? void 0 : _c.labels.forEach(function (label) {
            if (label.severe) {
                severe = true;
            }
        });
        (_d = data.parented) === null || _d === void 0 ? void 0 : _d.labels.forEach(function (label) {
            if (label.severe) {
                severe = true;
            }
        });
    }
    return severe;
}
function labelValue(defaultType, probably, data) {
    var _a;
    if (probably === null || probably === void 0 ? void 0 : probably.warning) {
        return probably.warning.kind;
    }
    var type = defaultType;
    (_a = data === null || data === void 0 ? void 0 : data.anchored) === null || _a === void 0 ? void 0 : _a.labels.forEach(function (label) {
        type = label.type.toString();
    });
    return type;
}
function buildWarnings(_a, _b, invoke, emitTelemetry) {
    var warnings = _a.warnings, loading = _a.loading;
    var catalogEnabled = _b.catalogEnabled, content = _b.content, probablyOrEager = _b.probablyOrEager, _includeUpstream = _b.includeUpstream, includeParented = _b.includeParented, shared = __rest(_b, ["catalogEnabled", "content", "probablyOrEager", "includeUpstream", "includeParented"]);
    if (!catalogEnabled) {
        return null;
    }
    var onClick = function () {
        invoke();
        emitTelemetry({ elevated: isSevere(probably, warnings), value: labelValue('warning', probably, warnings) });
    };
    var probably = probablyOrEager;
    if ((!warnings || loading) && (probably === null || probably === void 0 ? void 0 : probably.warning)) {
        return react_1.default.createElement(LabelButtons_1.LabelButton, __assign({ category: 'warning', kind: 'dehydrated', severe: isSevere(probably, warnings), content: content }, shared, { loading: loading !== null && loading !== void 0 ? loading : false, onClick: onClick }));
    }
    if (warnings) {
        return react_1.default.createElement(LabelButtons_1.LabelButton, __assign({}, warnings, shared, { loading: loading !== null && loading !== void 0 ? loading : false, onClick: onClick }));
    }
    return null;
}
function buildCertifications(_a, _b, invoke, emitTelemetry) {
    var certifications = _a.certifications, loading = _a.loading;
    var catalogEnabled = _b.catalogEnabled, content = _b.content, probablyOrEager = _b.probablyOrEager, _includeUpstream = _b.includeUpstream, includeParented = _b.includeParented, shared = __rest(_b, ["catalogEnabled", "content", "probablyOrEager", "includeUpstream", "includeParented"]);
    var onClick = function () {
        invoke();
        emitTelemetry({ elevated: false, value: labelValue('certification', probably, certifications) });
    };
    var probably = probablyOrEager;
    if ((!certifications || loading) && (probably === null || probably === void 0 ? void 0 : probably.certified)) {
        return react_1.default.createElement(LabelButtons_1.LabelButton, __assign({ category: 'certification', kind: 'dehydrated', content: content }, shared, { onClick: onClick, loading: loading !== null && loading !== void 0 ? loading : false }));
    }
    if (certifications) {
        return react_1.default.createElement(LabelButtons_1.LabelButton, __assign({}, certifications, shared, { onClick: onClick, loading: loading !== null && loading !== void 0 ? loading : false }));
    }
    return null;
}
function buildSensitivities(_a, _b, invoke) {
    var sensitivities = _a.sensitivities, loading = _a.loading;
    var catalogEnabled = _b.catalogEnabled, content = _b.content, probablyOrEager = _b.probablyOrEager, _includeUpstream = _b.includeUpstream, includeParented = _b.includeParented, shared = __rest(_b, ["catalogEnabled", "content", "probablyOrEager", "includeUpstream", "includeParented"]);
    if (!catalogEnabled) {
        return null;
    }
    var probably = probablyOrEager;
    if ((!sensitivities || loading) && (probably === null || probably === void 0 ? void 0 : probably.sensitivity)) {
        return react_1.default.createElement(LabelButtons_1.LabelButton, __assign({ category: 'sensitivity', kind: 'dehydrated', content: content }, shared, { onClick: invoke, loading: loading !== null && loading !== void 0 ? loading : false }));
    }
    if (sensitivities) {
        return react_1.default.createElement(LabelButtons_1.LabelButton, __assign({}, sensitivities, shared, { onClick: invoke, loading: loading !== null && loading !== void 0 ? loading : false }));
    }
    return null;
}
function useBuildTelemetryEvents(content_Type, testId, source, telemetryContext) {
    var emitWarning = (0, useTelemetrySender_1.useTelemetrySender)({
        type: 'label_opened',
        category: 'warning',
        source: source !== null && source !== void 0 ? source : testId,
        content_type: content_Type !== null && content_Type !== void 0 ? content_Type : undefined,
    }, 'empty', (0, HookContext_1.useContextWithOverride)(TelemetryContext_1.ReactTelemetryContext, telemetryContext));
    var emitCertification = (0, useTelemetrySender_1.useTelemetrySender)({
        type: 'label_opened',
        category: 'certification',
        source: source !== null && source !== void 0 ? source : testId,
        content_type: content_Type !== null && content_Type !== void 0 ? content_Type : undefined,
    }, 'empty', (0, HookContext_1.useContextWithOverride)(TelemetryContext_1.ReactTelemetryContext, telemetryContext));
    return [emitWarning, emitCertification];
}
function useRenderLabels(params) {
    var _a, _b;
    var _c = useLabels(params), invoke = _c[0], data = _c[1];
    var _d = react_1.default.useState(false), calledInitialInvoke = _d[0], setCalledInitialInvoke = _d[1];
    var labelsInMorePlacesEnabled = (0, HookContext_1.useContextWithOverride)(FeatureFlagsContext_1.FeatureFlagsContext, (_a = params.contextOverrides) === null || _a === void 0 ? void 0 : _a.featureFlags).labelsInMorePlacesEnabled;
    var _e = useBuildTelemetryEvents(params.content.contentType, params.testId, params.source, (_b = params.contextOverrides) === null || _b === void 0 ? void 0 : _b.telemetryContext), emitWarningTelemetryEvent = _e[0], emitCertificationTelemetryEvent = _e[1];
    var debouncedData = (0, useDebounceWithLoading_1.useDebounceWithLoading)(data, LABELS_CACHE_RELOAD_TIME);
    // TODO o.dadabhoy This will force an update on the lazy queries if eager is true. Not the cleanest approach, but it will do the job for now.
    // We should instead parameterize the useLazyQuery/useQuery and if eager is true we should pass the correct one in.
    if (!calledInitialInvoke && params.probablyOrEager === 'eager') {
        invoke();
        setCalledInitialInvoke(true);
    }
    var warnings = labelsInMorePlacesEnabled ? buildWarnings(debouncedData, params, invoke, emitWarningTelemetryEvent) : null;
    var certifications = labelsInMorePlacesEnabled ? buildCertifications(debouncedData, params, invoke, emitCertificationTelemetryEvent) : null;
    var sensitivities = labelsInMorePlacesEnabled ? buildSensitivities(debouncedData, params, invoke) : null;
    return { warnings: warnings, certifications: certifications, sensitivities: sensitivities };
}
exports.useRenderLabels = useRenderLabels;
//# sourceMappingURL=useRenderLabels.js.map